module.exports = __webpack_public_path__ + "static/master-class-b9b91c752ce0b840f5f86bec52038b06.png";